import tippy from 'tippy.js'

export function initTooltips() {
  const elements = document.querySelectorAll('[data-tooltip]')
  if (!elements.length) return
  tippy(elements, {
    content(reference) {
      return reference.getAttribute('data-tooltip') || ''
    },
    allowHTML: false,
    theme: 'light',
    animation: 'shift-away-subtle',
    maxWidth: 260,
    placement: 'bottom-end',
    interactive: false,
    arrow: false,
    delay: [0, 0],
    offset: [0, 8]
  })
}

document.addEventListener('DOMContentLoaded', initTooltips)

